import {
  getSessionToken,
} from './sessionAuth';

export const getSessionNavigationUrl = (
  path: string
): string => {
  const token = getSessionToken();

  if (!token) {
    return path;
  }

  const separator =
    path.includes('#') ? '&' : '#';

  return (
    path +
    separator +
    'session_token=' +
    encodeURIComponent(token)
  );
};

const appendHashParameter = (
  url: string,
  key: string,
  value: string
): string => {
  const separator =
    url.includes('#') ? '&' : '#';

  return (
    url +
    separator +
    encodeURIComponent(key) +
    '=' +
    encodeURIComponent(value)
  );
};

export const getCourseActivityNavigationUrl = (
  path: string,
  launchToken: string
): string =>
  appendHashParameter(
    getSessionNavigationUrl(path),
    'course_activity_launch',
    launchToken
  );

export const navigateWithSession = (
  path: string
): void => {
  window.location.assign(
    getSessionNavigationUrl(path)
  );
};

export const replaceWithSession = (
  path: string
): void => {
  window.location.replace(
    getSessionNavigationUrl(path)
  );
};

export const replaceWithSessionAndCourseActivity = (
  path: string,
  launchToken: string
): void => {
  window.location.replace(
    getCourseActivityNavigationUrl(
      path,
      launchToken
    )
  );
};
